/* eslint-disable camelcase */
import React from 'react'
import ChipRectangle from 'components/ChipRectangle'

const LABEL = 'Full size'

/**
 * @param {ProductBadgesProps} props
 * @returns {JSX.Element}
 * @constructor
 */
export default function ProductBadgeFullSize (props) {
  const {
    hasFullSizeBadge,
    isSetWithAllFullSize,
    isMini
  } = props

  if (
    !hasFullSizeBadge ||
    isSetWithAllFullSize ||
    isMini
  ) {
    return <></>
  }

  return (
    <ChipRectangle>
      {LABEL}
    </ChipRectangle>
  )
}
